import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Camera } from 'lucide-react';
import { Card, CardContent } from './ui/card';

// Custom intersection icon component
const IntersectionIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M2 10 L8 10 L8 2" />
    <path d="M22 10 L16 10 L16 2" />
    <path d="M2 14 L8 14 L8 22" />
    <path d="M22 14 L16 14 L16 22" />
    <path d="M12 2 L12 4" strokeDasharray="2 2" />
    <path d="M12 6 L12 8" strokeDasharray="2 2" />
    <path d="M12 16 L12 18" strokeDasharray="2 2" />
    <path d="M12 20 L12 22" strokeDasharray="2 2" />
    <path d="M2 12 L4 12" strokeDasharray="2 2" />
    <path d="M6 12 L8 12" strokeDasharray="2 2" />
    <path d="M16 12 L18 12" strokeDasharray="2 2" />
    <path d="M20 12 L22 12" strokeDasharray="2 2" />
  </svg>
);

// Custom highway icon component
const HighwayIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M4 22 L10 2 L14 2 L20 22 Z" fill="currentColor" />
    <path d="M5.5 22 L10.5 4 L10.8 4 L6.2 22 Z" fill="white" opacity="0.9" />
    <path d="M17.8 22 L13.2 4 L13.5 4 L18.5 22 Z" fill="white" opacity="0.9" />
    <rect x="11.5" y="5" width="1" height="2.5" fill="white" opacity="0.9" />
    <rect x="11.5" y="9" width="1" height="2.5" fill="white" opacity="0.9" />
    <rect x="11.5" y="13" width="1" height="2.5" fill="white" opacity="0.9" />
    <rect x="11.5" y="17" width="1" height="2.5" fill="white" opacity="0.9" />
  </svg>
);

const ApplicationsSection = () => {
  const { t } = useLanguage();

  const icons = [IntersectionIcon, HighwayIcon, Camera];

  return (
    <section id="applications" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold mb-6" style={{ color: '#1F4FD8' }}>
            {t.applications.title}
            {t.applications.titleHighlight}
          </h2>
          <p className="text-xl text-slate-600">
            {t.applications.subtitle}
          </p>
        </div>

        {/* Applications Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.applications.items.map((item, index) => {
            const IconComponent = icons[index];
            return (
              <Card
                key={index}
                className="group bg-white border border-slate-200 hover:border-blue-200 shadow-sm hover:shadow-lg transition-all duration-300"
              >
                <CardContent className="p-6">
                  <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300" style={{ backgroundColor: '#1F4FD8', boxShadow: '0 8px 20px rgba(31, 79, 216, 0.2)' }}>
                    <IconComponent className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-4">
                    {item.title}
                  </h3>
                  <ul className="space-y-2">
                    {item.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-start gap-2 text-sm text-slate-600">
                        <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#1F4FD8' }} />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ApplicationsSection;
